import { useState, useContext } from "react"
import { GlobalContext } from "context/context/GlobalContext"
import { executeShipingGroupAction } from "services/ShippingGroupService"
import { TransactionCodeEnum } from "enums/TransactionCodeEnum"
import { NOTIFY_DELIVERED } from "helpers/constHelper"
import Logger from "classes/Logger"
import { ProcessShippingGroupActionType } from "types/OrderType"
import { EShippinggroupAction } from "enums/shippinggroupEmun"

const UseDeliveredReservaOrder = ({
  shippingGroupId,
  setFinishedShippingGroupAction,
}: ProcessShippingGroupActionType) => {
  const [loadingDeliveredReserva, setLoadingDeliveredReserva] = useState(false)

  const { notification, errorHander } = useContext(GlobalContext)

  const handleClickDeliveredReservaOrder = async () => {
    setLoadingDeliveredReserva(true)

    try {
      const {
        data: { code },
      } = await executeShipingGroupAction({
        shippingGroupId,
        action: EShippinggroupAction.delivered,
      })

      setLoadingDeliveredReserva(false)

      if (code === TransactionCodeEnum.ok) {
        setFinishedShippingGroupAction(true)

        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "Productos entregados correctamente",
            title: NOTIFY_DELIVERED,
            type: "success",
          },
        })
      }
    } catch (error: any) {
      setLoadingDeliveredReserva(false)
      Logger.error(error)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
    }
  }

  return {
    handleClickDeliveredReservaOrder,
    loadingDeliveredReserva,
  }
}

export default UseDeliveredReservaOrder
